import { useTranslation } from "react-i18next";
import { Dimmer, Loader, Message } from "semantic-ui-react";

function LoadResolver(props) {
  const { isLoading, error, children, hideWhenLoading } = props;
  const { t } = useTranslation("common");

  if (isLoading)
    return (
      <Dimmer.Dimmable>
        <Dimmer active inverted>
          <Loader inverted>{t("loading")}</Loader>
        </Dimmer>
        {hideWhenLoading ? null : children}
      </Dimmer.Dimmable>
    );

  if (error) return <Message negative header={t("load_resolver_load_error")} content={error} />;

  return children;
}

export default LoadResolver;
